import React, { useCallback, useContext, useState } from "react";

export const NotificationContext = React.createContext({
  notification: null,
  addNotification: () => { },
  removeNotification: () => { },
});

let externalAddNotificationRef = { current: null };

export function NotificationProvider({ children }) {
  const [notification, setNotification] = useState(null);

  const removeNotification = useCallback(() => {
    setNotification(null);
  }, []);


  const addNotification = useCallback((message, status) => {
    setNotification({ message, status });
  }, []);

  externalAddNotificationRef.current = addNotification;

  const contextValue = {
    notification,
    addNotification,
    removeNotification
  };

  return (
    <NotificationContext.Provider value={contextValue}>
      {children}
    </NotificationContext.Provider>
  );
}

export function useNotification() {
  const { notification, addNotification, removeNotification } =
    useContext(NotificationContext);
  return { notification, addNotification, removeNotification };
}

export function notifyExternally(message, status = "error") {
  externalAddNotificationRef.current?.(message, status);
}

